export const ROLE_NAMES = {
  'ADM': 'Správce',
  'USR': 'Uživatel',
  'BLK': 'Blokovaný'
}
